module.exports = __webpack_public_path__ + "img/bank-example-1.b06eb1f7.png";